"use strict";

import gsap from "gsap";
import { CustomEase, Flip } from "gsap/all";

const fromStudyToStudyAnimation = (container, trigger) => {
	gsap.registerPlugin(CustomEase);
	gsap.registerPlugin(Flip);

	if (trigger !== "forward" || trigger !== "back" || trigger !== "popstate") {
		const selected = trigger.parentElement.parentElement.parentElement;
		const title = container.querySelector(".section-heading");
		const image = selected.querySelector(".project-display");
		const imgInner = image.children[0];
		const content = selected.querySelector(".project-content");
		const btns = container.querySelectorAll("#rightBtn, #leftBtn");
		const counter = container.querySelector(".slide-counter");

		const h = image.offsetHeight;
		const t = image.offsetTop;
		const vh = window.innerHeight;
		const fp = vh * 0.15;
		const tp = ((t - fp) / h) * 100;

		const tMaster = gsap.timeline();

		const state = Flip.getState(image, {
			props: "transform",
		});

		image.style.transform =
			tp < 0 ? `translateY(${tp * -1}%) rotate(-4deg)` : `translateY(-${tp}%) rotate(-4deg)`;
		selected.classList.add("leave");

		const fl = Flip.from(
			state,
			{
				duration: 1,
				ease: "power4.inOut",
			},
			"<0.3"
		);

		const t1 = gsap.timeline();

		t1.to(content, { autoAlpha: 0, duration: 0.4, ease: "power4.inOut" }, "<")
			.to(
				imgInner,
				{
					height: "90%",
					rotate: 0,
					duration: 1,
					ease: "power4.inOut",
				},
				"<"
			)
			.to(title, { opacity: 0, duration: 0.2, ease: "none" }, "<")
			.to(btns, { opacity: 0, duration: 0.2, ease: "none" }, "<")
			.to(counter, { opacity: 0, duration: 0.2, ease: "none" }, "<");

		tMaster.add(t1).add(fl, "<");

		return tMaster;
	}
};

export default fromStudyToStudyAnimation;
